export var isGatsbyImage = function isGatsbyImage(image) {
  return typeof image !== 'string' && !!image && (!!image.fixed || !!image.fluid);
};
export var isServerSideRendering = function isServerSideRendering() {
  return typeof window === 'undefined';
};